import { render, staticRenderFns } from "./MoleculeSidebarHeader.vue?vue&type=template&id=46e55242&"
import script from "./MoleculeSidebarHeader.vue?vue&type=script&lang=js&"
export * from "./MoleculeSidebarHeader.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeSidebarHeader.vue?vue&type=style&index=0&id=46e55242&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/lang/MoleculeSidebarHeader.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fcomponents%2Fmolecules%2Fproject%2Fbuilding%2FMoleculeSidebarHeader.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default,AtomsProjectBuildingAtomSidebarTitle: require('/app/components/atoms/project/building/AtomSidebarTitle.vue').default,AtomsCommonAtomSelect: require('/app/components/atoms/common/AtomSelect.vue').default,AtomsCommonAtomCheck: require('/app/components/atoms/common/AtomCheck.vue').default,AtomsCommonAtomButton: require('/app/components/atoms/common/AtomButton.vue').default,AtomsCommonAtomRadio: require('/app/components/atoms/common/AtomRadio.vue').default})
